import React from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import { appendLocale } from '../../../utils/helper';

const AccountBank = (props) => {
    const {
        bankAccountData,
        isFetching,
    } = props;

    const dict = useDict();

    const renderList = () => {
        if (isFetching) {
            <tbody>
                <tr>
                    <td>{dict.fetchingData}</td>
                </tr>
            </tbody>;
        }

        return (
            <tbody>
                {bankAccountData && bankAccountData.length > 0 ? (
                    bankAccountData.map((data, index) => (
                        <tr key={data.account_no} data-private>
                            <td style={{ width: '5%', fontWeight: 'bold' }}>
                                {index + 1}.{' '}
                            </td>
                            <td>
                                <span style={{ fontWeight: 'bold' }}>
                                    {dict.bank}:{' '}
                                </span>
                                {data.bank[appendLocale('name')]}
                                <br />
                                <span style={{ fontWeight: 'bold' }}>
                                    {dict.accName}:{' '}
                                </span>
                                {data.account_owner_name}
                                <br />
                                <span style={{ fontWeight: 'bold' }}>
                                    {dict.accNo}:{' '}
                                </span>
                                {data.account_no}
                                <br />
                                <span style={{ fontWeight: 'bold' }}>
                                    {dict.accType}:{' '}
                                </span>
                                {data.bank_account_type[appendLocale('name')]}
                                <br />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td>{dict.noRecord}</td>
                    </tr>
                )}
            </tbody>
        );
    };

    return (
        <>
            <Card className="card_accbank">
                <CardBody>
                    <Table responsive className="table--bordered">
                        {renderList()}
                    </Table>
                </CardBody>
            </Card>

            <div style={{ padding: '1%', marginTop: '1%' }}>
                <div>
                    {dict.contactUs1}{' '}
                    <a href="mailto:thaisupport@capbay.com">thaisupport@capbay.com</a>{' '}
                    {dict.contactUs2}
                </div>
                <br />
            </div>
        </>
    );
};

export default AccountBank;
